export default __webpack_public_path__ + "static/media/scouts-life-jackets.6b26011c.jpg";